import React, { useState } from 'react'
import "../Earlyclosure/Earlyclosure.css"
import Header from '../../../Components/Dashboard/Header/Header'
import Sidebar from '../../../Components/Dashboard/Sidebar/Sidebar';
import TimePicker from 'react-multi-date-picker/plugins/time_picker';
import DatePicker from 'react-multi-date-picker';
import { BiHomeAlt } from 'react-icons/bi';
import { MdKeyboardArrowRight } from 'react-icons/md';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Apiurl, GetToken } from '../../../Utils/utils';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import Loader from '../../../Components/loader/loader';

const Earlyclosure = () => {
    const LoginToken = GetToken();
    const [showSidebar, setShowSidebar] = useState(true);
    const [closureTime, setclosureTime] = useState("");
    const [loading, setLoading] = useState(false);
    const [earlyclosure, setEarlyclosure] = useState('')
    const currentDate = new Date().toISOString().split("T")[0];

    const navigate = useNavigate('')

    const validations = () => {
        if (earlyclosure === "") {
            toast.error("Please select choose date")
            return false
        }
        if (closureTime === "") {
            toast.error("Please select out time")
            return false
        }
        return true
    }

    const AddClosureTime = () => {
        if (!validations()) return

        const data = {};
        data.Date = earlyclosure;
        data.EarlyClosureOuttime = moment(new Date(closureTime)).format("HH:mm:ss.SS");

        setLoading(true);

        const option = {
            method: "POST",
            headers: {
                "access-control-allow-origin": "*",
                "content-type": "application/json",
                authorization: `Bearer ${LoginToken}`,
            },
            url: `${Apiurl()}/Admin/AddClosureTime`,
            data: { "data": JSON.stringify(data) },
        };

        axios(option)
            .then((e) => {
                setLoading(false);

                if (e?.status === 200) {
                    toast.success(e?.data?.message);
                    navigate("/Hr/Getattendance")
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error(error?.response?.data?.message);
            });
    };

    return (
        <>
            {loading ? <Loader /> : null}

            <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

            <div className="d-flex">
                <Sidebar showSidebar={showSidebar} />
                <div
                    className={
                        showSidebar
                            ? 'Earlyclosure-main-container'
                            : 'Earlyclosure-main-container-new'
                    }
                >
                    <div className='Earlyclosure-flow'>

                        <div className='Earlyclosure-heading'>
                            <h3>Early Closure</h3>
                        </div>

                        <div className="EMP-all-employees-sheet col">
                            <div className="EMP-home-icon-sheet">
                                <BiHomeAlt className="EMP-home-icon-header-sheet" />
                            </div>
                            <div className="EMP-arrow-icon-sheet">
                                <MdKeyboardArrowRight />
                            </div>
                            <div className="EMP-employee-text-sheet">
                                <p>Attendance</p>
                            </div>
                            <div className="EMP-arrow-icon-sheet">
                                <MdKeyboardArrowRight />
                            </div>
                            <div className="EMP-all-employee-text-sheet">
                                <p>Early Closure</p>
                            </div>
                        </div>
                    </div>

                    <div className='Earlyclosure-outter-container'>
                        <div className='Earlyclosure-flex'>

                            <div className="Earlyclosure-input col">
                                <label>Choose date</label>
                                <input
                                    type="date"
                                    value={earlyclosure}
                                    onChange={(e) => setEarlyclosure(e.target.value)}
                                    max={currentDate}
                                />
                            </div>

                            <div className='Earlyclosure-input col'>
                                <label>Out time</label>
                                <DatePicker
                                    plugins={[<TimePicker />]}
                                    format="HH:mm ss"
                                    value={closureTime}
                                    disableDayPicker
                                    onChange={(date) => setclosureTime(new Date(date))}
                                />
                            </div>

                        </div>

                        <button onClick={AddClosureTime} className='Earlyclosure-button'>
                            Submit
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Earlyclosure;